import React, { useEffect, useState } from "react";
import eventBus from "src/utils/eventBus";
import { DevConfig } from "src/utils/config";

const ChannelPreviewModal: React.FC = () => {
    const [channel, setChannel] = useState<any>(null);
    const [isVisible, setIsVisible] = useState(false);
    const [isHandlingBack, setIsHandlingBack] = useState(false);
    
    useEffect(() => {
            const onShowChannelPreview = (data: { channel }) => {
                setChannel(data.channel)
                setTimeout(() => setIsVisible(true), 25);
                if (window.history.state !== "modal-open") {
                    window.history.pushState("modal-open", "", window.location.pathname);
                }
        };

        eventBus.on("channelPreviewModal:show", onShowChannelPreview);

        return () => {
            eventBus.off("channelPreviewModal:show", onShowChannelPreview);
        };
    }, []);

    useEffect(() => {
        if (isVisible) {
            document.body.style.overflow = "hidden";

            const handleBackButton = () => {
                if (!isVisible || isHandlingBack) return;

                setIsHandlingBack(true);
                closeModal();

                setTimeout(() => setIsHandlingBack(false), 200);
            };

            window.addEventListener("popstate", handleBackButton);

            return () => {
                document.body.style.overflow = "auto";
                window.removeEventListener("popstate", handleBackButton);
                setIsHandlingBack(false);
            };
        }
    }, [isVisible, isHandlingBack]);

    const closeModal = () => {
        setIsVisible(false); 
        setTimeout(() => setChannel(null), 300);
    };

    const ClickLink = (path: string) => {
        window.open(path, "_blank");
    };

    if (!channel) return null;
    
    const SafeText = ({ text }) => {
        if (text !== '' && text !== null && text !== undefined){
        return (
            <div className="preview-description" dir="auto" dangerouslySetInnerHTML={{ __html: text.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/&lt;br\/&gt;/g, "<br/>") }} />
        );
        } else {
            return (
                <div className="preview-description" dir="auto">{text}</div>
            )
        }
    };

    return (
        <>
            <div className={`overlay ${isVisible ? "active" : ""}`} onClick={closeModal}></div>
            <div className={`modal fade ${isVisible ? "show" : ""} d-block`} tabIndex={-1} >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content p-3 text-left" style={{ borderRadius: "8px" }}>
                        <div style={{alignSelf: "end"}}>
                            <button type="button" className="btn-close" onClick={closeModal}></button>
                        </div>
                        <div className="modal-body px-0">
                            <div className="preview-img-box">
                                <span><img className="preview-img" src={channel.photo} /></span>
                            </div>
                            <div className="preview-title" dir="auto">
                                <span dir="auto">{channel.channel_title}</span>
                            </div>
                            <div className="preview-subscribe">{channel.subscribe_cnt?.toLocaleString()} subscribers</div>
                            <SafeText text={channel.channel_about} />
                            <div className="preview-button-box">
                                <button className="preview-button" onClick={() => ClickLink(`${DevConfig.TELEGRAM_URL}/${channel.channel_id}`)} >채널로 이동하기</button>
                            </div>
                        </div>        
                    </div>
                </div>
            </div>            
        </>
    );
};

export default ChannelPreviewModal;
